var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-menu",
    {
      attrs: { value: _vm.isFocused, up: _vm.up },
      on: {
        blur: function ($event) {
          return _vm.onBlur()
        },
      },
    },
    [
      _c("w-input", {
        attrs: {
          slot: "activator",
          value: _vm.input,
          fancy: _vm.fancy,
          label: _vm.label,
          icon: _vm.icon,
          "icon-click-handler": _vm._iconClickHandler,
        },
        on: {
          focus: function ($event) {
            return _vm.onFocus()
          },
          blur: function ($event) {
            return _vm.onBlur()
          },
          input: function ($event) {
            return _vm.onInput($event)
          },
          keyup: [
            function ($event) {
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              return _vm.onKeyUp($event)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              return _vm.onEnter()
            },
          ],
        },
        slot: "activator",
      }),
      _vm.isFocused
        ? _c(
            "w-scroll-view",
            [
              _c("app-prop-select-group", {
                staticClass: "root-group",
                style: { maxHeight: `${_vm.getMaxHeight()}px` },
                attrs: {
                  group: _vm.items,
                  "is-root": true,
                  "search-text": _vm.input,
                  "hovered-value": _vm.hoveredValue,
                  "add-empty": _vm.allowEmpty,
                },
                on: {
                  click: function ($event) {
                    return _vm.onClick($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }